function Profile() {
    return (
        <div>
            <a className="profile row" href="./self">
                <div className="icon col-md-5">
                    <img src={`${process.env.PUBLIC_URL}/icon.jpg`}/>
                </div>
                <div className="introduction col-md-7">
                    <h1>Yoshi</h1>
                    <p>Portfolio of Red_Yoshi_.<br />Creating Music, Programs, and more.</p>
                </div>
            </a>
        </div>
    )
}

export default Profile;